import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ChipToggleComponent } from './chip-toggle.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    ChipToggleComponent,
  ],
  declarations: [ ChipToggleComponent],
})
export class  ChipToggleModule {}
